import * as types from './types';

const initialState = {
  messageActivity: { loading: 'loaded', counter: null },
  userActivity: null,
  loading: false,
  fetched: false,
  success: false,
  fetchActivityError: false,
  putActivityError: false,
  deleteActivityError: false,
  frequencies: [],
  fetchFrequenciesError: false
};

function userActivityReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_USER_ACTIVITY:
      return {
        ...state,
        loading: true,
        userActivity: null,
        fetched: false,
        fetchActivityError: false,
        success: false
      };

    case types.GET_USER_ACTIVITY_COMPLETED:
      return {
        ...state,
        loading: false,
        fetched: true,
        userActivity: action.payload
      };

    case types.GET_USER_ACTIVITY_FAILED:
      return {
        ...state,
        loading: false,
        fetched: true,
        fetchActivityError: true
      };

    case types.PUT_USER_ACTIVITY:
      return {
        ...state,
        loading: true,
        success: false
      };

    case types.PUT_USER_ACTIVITY_COMPLETED:
      return {
        ...state,
        loading: false,
        success: true
      };

    case types.PUT_USER_ACTIVITY_FAILED:
      return {
        ...state,
        loading: false,
        success: false,
        putActivityError: true
      };

    case types.DELETE_USER_ACTIVITY:
      return {
        ...state,
        loading: true,
        success: false,
        deleteActivityError: false
      };

    case types.DELETE_USER_ACTIVITY_COMPLETED:
      return {
        ...state,
        loading: false,
        success: true
      };

    case types.DELETE_USER_ACTIVITY_FAILED:
      return {
        ...state,
        loading: false,
        success: false,
        deleteActivityError: true
      };

    case types.GET_FREQUENCIES:
      return {
        ...state,
        loading: true
      };

    case types.GET_FREQUENCIES_COMPLETED:
      return {
        ...state,
        loading: false,
        frequencies: action.payload
      };

    case types.GET_FREQUENCIES_FAILED:
      return {
        ...state,
        loading: false,
        fetchFrequenciesError: true
      };

    case types.GET_MESSAGES_UNREAD:
      return {
        ...state,
        messageActivity: { ...state.messageActivity, ...{ loading: 'loading' } }
      };

    case types.GET_MESSAGES_UNREAD_FAILED:
      return {
        ...state,
        messageActivity: { ...state.messageActivity, ...{ loading: 'error' } }
      };

    case types.GET_MESSAGES_UNREAD_COMPLETED:
      return {
        ...state,
        messageActivity: {
          ...state.messageActivity,
          ...{ loading: 'loaded', counter: action.payload }
        }
      };

    default:
      return state;
  }
}

export default userActivityReducer;
